import React from 'react';
import { change as changeFieldValue, formValueSelector, Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Select from 'react-select';
import {
  maxValueMonetario,
  minValueMonetario,
  renderFieldCheck,
  renderFieldMonetarioFormulario,
  renderFieldQuilogramasFormulario,
  renderFieldText,
  requiredSelect,
  required,
} from '../../util/inputs';
import { tamanhoArquivoUpload } from '../../util/applicationContext';
import { showErrorMsg } from '../../util/messagesUtil';
import { withRouter } from 'react-router-dom';
import Titulo from '../comum/Titulo';
import { getPerfisVendedores, getVendedorAgencia } from '../../security/securityContext';
import Autorizacao, { validaPerfis } from '../../security/Autorizacao';
import { cadastrarBagagem, selecionaBagagem } from '../../actions/bagagem/bagagemActions';

export const VALORCOMBINADO = 'VALOR_COMBINADO';

const parseBRL = (v) => {
  if (v === null || v === undefined) return 0;
  const s = String(v).replace(/[^\d.,-]/g, '').replace(/\./g, '').replace(',', '.');
  const n = parseFloat(s);
  return isNaN(n) ? 0 : n;
};

function calcularValorTotal(reservasSelecionadas, formValues) {
  let total = 0;
  reservasSelecionadas.forEach(r => {
    total += Math.round(parseBRL(formValues && formValues[`valor_${r.id}`]) * 100);
  });
  return Number((total / 100).toFixed(2));
}


function validarFormulario(values, props) {
  const errors = {};
  const reservas = (props && props.reservasSelecionadas) || [];

  reservas.forEach(r => {
    const rid = r.id;
    const valItem = parseBRL(values[`valor_${rid}`]);
    const selecionouAlguma = !!values[`dinheiro_${rid}`] || !!values[`cartao_${rid}`] || !!values[`pix_${rid}`];

      if (!selecionouAlguma) {
          errors[`dinheiro_${rid}`] = 'Selecione pelo menos uma forma de pagamento.';
          return;
        }


    if (selecionouAlguma) {
      const vDin = values[`dinheiro_${rid}`] ? parseBRL(values[`valorDinheiro_${rid}`]) : 0;
      const vCar = values[`cartao_${rid}`] ? parseBRL(values[`valorCartao_${rid}`]) : 0;
      const vPix = values[`pix_${rid}`] ? parseBRL(values[`valorPIX_${rid}`]) : 0;
      const soma = Number((vDin + vCar + vPix).toFixed(2));

      if (values[`dinheiro_${rid}`] && vDin <= 0) {
        errors[`valorDinheiro_${rid}`] = 'O valor em dinheiro não pode ser zero.';
      }
      if (values[`cartao_${rid}`] && vCar <= 0) {
        errors[`valorCartao_${rid}`] = 'O valor em cartão não pode ser zero.';
      }
      if (values[`pix_${rid}`] && vPix <= 0) {
        errors[`valorPIX_${rid}`] = 'O valor em PIX não pode ser zero.';
      }

      if (Math.abs(soma - valItem) > 0.009) { // tolerância de arredondamento
        const msg = 'A soma das formas de pagamento deve ser igual ao valor desta bagagem.';
        if (values[`dinheiro_${rid}`]) errors[`valorDinheiro_${rid}`] = msg;
        if (values[`cartao_${rid}`]) errors[`valorCartao_${rid}`] = msg;
        if (values[`pix_${rid}`]) errors[`valorPIX_${rid}`] = msg;
      }

      // Campos extras quando cartão/PIX selecionados
      if (values[`cartao_${rid}`]) {
        // exemplo opcional: exigir número do comprovante quando cartão
        // if (!values[`numeroComprovante_${rid}`]) errors[`numeroComprovante_${rid}`] = 'Informe o número do comprovante';
      }
      if (values[`pix_${rid}`]) {
        // exemplo opcional: exigir número do comprovante PIX
        // if (!values[`numeroComprovantePIX_${rid}`]) errors[`numeroComprovantePIX_${rid}`] = 'Informe o número do comprovante PIX';
      }
    }
  });

  return errors;
}

class PainelCadastroBagagem extends React.Component {

  componentDidMount() {
    if (this.props.reservasSelecionadas && this.props.reservasSelecionadas.length) {
      this.props.reservasSelecionadas.forEach(it => {
          // deixa o item Valor combinado selecionado por padrão
          this.props.changeFieldValue('formularioCadastroBagagem', `tipoCalculo_${it.id}`, { 
            value: 'VALOR_COMBINADO', 
            label: 'Valor combinado' 
          });
      })
    }
  }

  handleToggleForma = (reservaId, forma) => {
    const { changeFieldValue, formValues } = this.props;
    const flagField = `${forma}_${reservaId}`; // dinheiro_#, cartao_#, pix_#
    const isAtivo = !!(formValues && formValues[flagField]);
    const novo = !isAtivo;

    changeFieldValue('formularioCadastroBagagem', flagField, novo);

    if (novo) {
      const jaSelecionadas = [ 'dinheiro', 'cartao', 'pix' ]
        .filter(f => !!(formValues && formValues[`${f}_${reservaId}`]))
        .length;
      if (jaSelecionadas === 0) {
        const valorItem = formValues && formValues[`valor_${reservaId}`];
        const valorField = (forma === 'dinheiro') ? `valorDinheiro_${reservaId}`
                          : (forma === 'cartao') ? `valorCartao_${reservaId}`
                          : `valorPIX_${reservaId}`;
        changeFieldValue('formularioCadastroBagagem', valorField, valorItem);
      }
    } else {
      if (forma === 'dinheiro') {
        changeFieldValue('formularioCadastroBagagem', `valorDinheiro_${reservaId}`, null);
      } else if (forma === 'cartao') {
        changeFieldValue('formularioCadastroBagagem', `valorCartao_${reservaId}`, null);
        changeFieldValue('formularioCadastroBagagem', `numeroComprovante_${reservaId}`, null);
        changeFieldValue('formularioCadastroBagagem', `quantidadeParcelas_${reservaId}`, null);
        changeFieldValue('formularioCadastroBagagem', `base64Comprovante_${reservaId}`, null);
        changeFieldValue('formularioCadastroBagagem', `nomeComprovanteVenda_${reservaId}`, null);
      } else if (forma === 'pix') {
        changeFieldValue('formularioCadastroBagagem', `valorPIX_${reservaId}`, null);
        changeFieldValue('formularioCadastroBagagem', `numeroComprovantePIX_${reservaId}`, null);
        changeFieldValue('formularioCadastroBagagem', `base64ComprovantePIX_${reservaId}`, null);
        changeFieldValue('formularioCadastroBagagem', `nomeComprovanteVendaPIX_${reservaId}`, null);
      }
    }
  };


  handleAnexarCartao = (e, reservaId) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (!/\.(jpe?g|png|pdf)$/i.test(file.name)) return;
    if (file.size > tamanhoArquivoUpload) {
      showErrorMsg('Tamanho do arquivo excede 20 MB');
      return;
    }
    this.converterParaBase64(file, 'CARTAO', reservaId);
  };

  handleAnexarPix = (e, reservaId) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (!/\.(jpe?g|png|pdf)$/i.test(file.name)) return;
    if (file.size > tamanhoArquivoUpload) {
      showErrorMsg('Tamanho do arquivo excede 20 MB');
      return;
    }
    this.converterParaBase64(file, 'PIX', reservaId);
  };

  converterParaBase64 = (file, formaPagamento, reservaId) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (formaPagamento === 'PIX') {
        this.props.changeFieldValue('formularioCadastroBagagem', `base64ComprovantePIX_${reservaId}`, reader.result);
        this.props.changeFieldValue('formularioCadastroBagagem', `nomeComprovanteVendaPIX_${reservaId}`, file.name);
      } else {
        this.props.changeFieldValue('formularioCadastroBagagem', `base64Comprovante_${reservaId}`, reader.result);
        this.props.changeFieldValue('formularioCadastroBagagem', `nomeComprovanteVenda_${reservaId}`, file.name);
      }
    };
    reader.readAsDataURL(file);
  };

  removerArquivo = (formaPagamento, reservaId) => {
    if (formaPagamento === 'PIX') {
      this.props.changeFieldValue('formularioCadastroBagagem', `base64ComprovantePIX_${reservaId}`, null);
      this.props.changeFieldValue('formularioCadastroBagagem', `nomeComprovanteVendaPIX_${reservaId}`, null);
    } else {
      this.props.changeFieldValue('formularioCadastroBagagem', `base64Comprovante_${reservaId}`, null);
      this.props.changeFieldValue('formularioCadastroBagagem', `nomeComprovanteVenda_${reservaId}`, null);
    }
  };

  exibirAnexarCartao = (reservaId) => {
    const { formValues } = this.props;
    if (formValues && formValues[`base64Comprovante_${reservaId}`]) {
      return (
        <div className="row align-items-center mt-2">
          <div className='col-12 label-cancelamento'>
            <label>Comprovante:</label>
          </div>
          <div className='ml-4'>{formValues[`nomeComprovanteVenda_${reservaId}`]}</div>
          <button type="button" className="btn btn-editar" title='Remover' onClick={() => this.removerArquivo('CARTAO', reservaId)}>
            <i className="material-icons nav-icon" style={{ color: 'red' }}>&#xe14c;</i>
          </button>
        </div>
      );
    }
    return (
      <React.Fragment>
        <div className='input-wrapper mt-3'>
          <label className='btn-laranja' htmlFor={`input-file-cartao-${reservaId}`}>
            <div className='row align-items-center'>
              <i className="material-icons aberto">&#xe2c3;</i>
              <strong className='ml-2'>Anexar comprovante de pagamento</strong>
            </div>
          </label>
          <input id={`input-file-cartao-${reservaId}`} type='file' accept="image/png,image/jpeg,application/pdf" onChange={(e) => this.handleAnexarCartao(e, reservaId)} style={{ display: 'none' }} />
        </div>
        <label style={{ fontSize: 'smaller' }}>* Tamanho máximo permitido : 20 MB</label>
      </React.Fragment>
    );
  };

  exibirAnexarPix = (reservaId) => {
    const { formValues } = this.props;
    if (formValues && formValues[`base64ComprovantePIX_${reservaId}`]) {
      return (
        <div className="row align-items-center mt-2">
          <div className='col-12 label-cancelamento'>
            <label>Comprovante:</label>
          </div>
          <div className='ml-4'>{formValues[`nomeComprovanteVendaPIX_${reservaId}`]}</div>
          <button type="button" className="btn btn-editar" title='Remover' onClick={() => this.removerArquivo('PIX', reservaId)}>
            <i className="material-icons nav-icon" style={{ color: 'red' }}>&#xe14c;</i>
          </button>
        </div>
      );
    }
    return (
      <div className='input-wrapper mt-3'>
        <label className='btn-laranja' htmlFor={`input-file-pix-${reservaId}`}>
          <div className='row align-items-center'>
            <i className="material-icons aberto">&#xe2c3;</i>
            <strong className='ml-2'>Anexar comprovante de pagamento</strong>
          </div>
        </label>
        <input id={`input-file-pix-${reservaId}`} type='file' accept="image/png,image/jpeg,application/pdf" onChange={(e) => this.handleAnexarPix(e, reservaId)} style={{ display: 'none' }} />
      </div>
    );
  };

  exibirComboTipoCalculo = (event) => {
    const tiposCalculo = [
      { value: 'VALOR_COMBINADO', label: 'Valor combinado' },
      { value: 'VALOR_POR_KG', label: 'Valor por KG' },
      { value: 'PRECO_FIXO_MAIS_VALOR_POR_KG', label: 'Preço fixo + Valor Kg' },
    ];
    return (
      <div>
        <Select
          {...event.input}
          noOptionsMessage={() => 'Nenhuma opção encontrada'}
          placeholder='Tipo de cálculo'
          options={tiposCalculo}
          onChange={value => event.input.onChange(value)}
          onBlur={() => event.input.onBlur()}
          label="Tipo de cálculo"
        />
        {event.meta.touched && event.meta.error && (
          <span style={{ color: 'red' }}>{event.meta.error}</span>
        )}
      </div>
    );
  };

  ehPerfilVendedorAgencia = () => {    
    return validaPerfis([getVendedorAgencia(this.props.empresaSelecionada.id)]);
  }

  exibir = (reserva) => {
    const { formValues } = this.props;
    const rid = reserva.id;
    const temDinheiro = !!(formValues && formValues[`dinheiro_${rid}`]);
    const temCartao = !!(formValues && formValues[`cartao_${rid}`]);
    const temPix = !!(formValues && formValues[`pix_${rid}`]);

    return (
      <div className="col-12" key={rid}>
        <div className="card">
          <div className="card-body">
            <div className="alert alert-info" style={{ fontWeight: 'bold' }}>
              <strong>Reserva : {rid}</strong> - {reserva.passageiroDto.nome} - {reserva.descCidadeDestino} à {reserva.descCidadeOrigem}
            </div>

            <div className="form-row align-items-end">
              <div className="form-group col-md-3">
                <Field name={`tipoCalculo_${rid}`} validate={[requiredSelect]} component={this.exibirComboTipoCalculo} />
              </div>

              <div className="form-group col-md-3">                
                <Field
                  name={`peso_${rid}`}
                  type="number"
                  component={renderFieldQuilogramasFormulario}
                  css="form-control"
                  placeholder="Peso da bagagem"
                  validate={[required, minValueMonetario]}
                  label="Kg"
                />
              </div>

              <div className="form-group col-md-3">
                <Field
                  name={`valor_${rid}`}
                  type="text"
                  component={renderFieldMonetarioFormulario}
                  css="form-control"
                  placeholder="Valor da bagagem"
                  validate={[required, maxValueMonetario, minValueMonetario]}
                  readOnly={reserva.habilitadoPrecoFixoExcessoBagagem}
                />
              </div>
            </div>

            <div className="form-check form-check-inline d-flex justify-content-center">
              {!this.ehPerfilVendedorAgencia() ? <Field
                name={`cartao_${rid}`}
                type="checkbox"
                component={renderFieldCheck}
                label="Cartão"
                onChange={() => this.handleToggleForma(rid, 'cartao')}
              /> : ''}
              <Field
                name={`dinheiro_${rid}`}
                type="checkbox"
                component={renderFieldCheck}
                label="Dinheiro"
                onChange={() => this.handleToggleForma(rid, 'dinheiro')}
              />
              {!this.ehPerfilVendedorAgencia() ? <Field
                name={`pix_${rid}`}
                type="checkbox"
                component={renderFieldCheck}
                label="PIX"
                onChange={() => this.handleToggleForma(rid, 'pix')}
              />: ''}
            </div>

            {temDinheiro && (
              <div className="form-group">
                <Field
                  name={`valorDinheiro_${rid}`}
                  type="text"
                  component={renderFieldMonetarioFormulario}
                  validate={[required, maxValueMonetario, minValueMonetario]}
                  css="form-control col-md-8"
                  label="Valor em dinheiro"
                />
              </div>
            )}

            {temCartao && (
              <div>
                <div className="form-row">
                  <div className="form-group">
                    <Field
                      name={`valorCartao_${rid}`}
                      type="text"
                      component={renderFieldMonetarioFormulario}
                      validate={[required, maxValueMonetario, minValueMonetario]}
                      css="form-control col-md-8"
                      label="Valor em cartão"
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      name={`numeroComprovante_${rid}`}
                      type="text"
                      component={renderFieldText}
                      css="form-control col-md-8"
                      label="Número comprovante"
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      name={`quantidadeParcelas_${rid}`}
                      type="text"
                      component={renderFieldText}
                      label="Quantidade de parcelas"
                      css="form-control col-md-3"
                    />
                  </div>
                </div>
                <div className='form-row'>
                  <div className="form-group">
                    {this.exibirAnexarCartao(rid)}
                  </div>
                </div>
              </div>
            )}

            {temPix && (
              <div>
                <div className="form-row">
                  <div className="form-group">
                    <Field
                      name={`valorPIX_${rid}`}
                      type="text"
                      component={renderFieldMonetarioFormulario}
                      validate={[required, maxValueMonetario, minValueMonetario]}
                      css="form-control col-md-8"
                      label="Valor em PIX"
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      name={`numeroComprovantePIX_${rid}`}
                      type="text"
                      component={renderFieldText}
                      css="form-control col-md-8"
                      label="Número comprovante PIX"
                    />
                  </div>
                </div>
                <div className='form-row'>
                  <div className="form-group">
                    {this.exibirAnexarPix(rid)}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  handleCadastrarTodas = () => {
    const { reservasSelecionadas, formValues } = this.props;

    const bagagens = reservasSelecionadas.map(r => {
      const rid = r.id;
      const formasPagamento = [];

      if (formValues[`dinheiro_${rid}`]) {
          formasPagamento.push({ tipo: 'DINHEIRO', valor: parseBRL(formValues[`valorDinheiro_${rid}`]) });
      }

      if (formValues[`cartao_${rid}`]) {
         formasPagamento.push({
           tipo: 'CARTAO',
           valor: parseBRL(formValues[`valorCartao_${rid}`]),
           numeroComprovante: formValues[`numeroComprovante_${rid}`],
           quantidadeParcelas: formValues[`quantidadeParcelas_${rid}`],
           base64Comprovante: formValues[`base64Comprovante_${rid}`],
           nomeComprovante: formValues[`nomeComprovanteVenda_${rid}`],
         });
      }

      if (formValues[`pix_${rid}`]) {
         formasPagamento.push({
           tipo: 'PIX',
           valor: parseBRL(formValues[`valorPIX_${rid}`]),
           numeroComprovante: formValues[`numeroComprovantePIX_${rid}`],
           base64Comprovante: formValues[`base64ComprovantePIX_${rid}`],
           nomeComprovante: formValues[`nomeComprovanteVendaPIX_${rid}`],
         });
      }

      return {
        reservaId: rid,
        peso:  parseBRL(formValues[`peso_${rid}`]),
        valor: parseBRL(formValues[`valor_${rid}`]),
        valorTipoCalculoBagagem: formValues[`tipoCalculo_${rid}`].value,
        descTipoCalculoBagagem: formValues[`tipoCalculo_${rid}`].label,
        formasPagamento,
      };
    });

    const payload = { bagagens };
    console.log('Objeto para cadastro:', payload);
    this.props.cadastrarBagagem(payload).then((response) => {
      // Seleciona a primeira bagagem cadastrada para exibir no recibo
      if (response.payload && response.payload.length > 0) {
        this.props.selecionaBagagem(response.payload[0]);
      }
      // Redireciona para o recibo da bagagem
      this.props.history.push('/recibo-bagagem');
    }).catch(error => {
      console.error('Erro ao cadastrar bagagens:', error);
      if (error.response) {
        const { violacoes } = error.response.data;
        
        violacoes.forEach(violacao => {
          console.error(`Tipo: ${violacao.tipo}`);
          console.error(`Mensagem: ${violacao.mensagem}`);
                    
          showErrorMsg(violacao.mensagem);
        });
        
      } else {        
        showErrorMsg('Erro ao cadastrar bagagens. Verifique os dados e tente novamente.');
      }
    });
  };

  render() {
    const { empresaSelecionada, reservasSelecionadas, formValues } = this.props;
    const valorTotal = calcularValorTotal(reservasSelecionadas, formValues || {});

    return (
      <Autorizacao perfisPermitidos={[...getPerfisVendedores(empresaSelecionada.id)]} empresaSelecionada={empresaSelecionada}>
        <div>
          <div className="row internas">
            <Titulo texto="Pesquisar Reservas" urlRetorno="/painel-pesquisar-bilhete" />
            {reservasSelecionadas.map(r => this.exibir(r))}
          </div>

          <div className="d-flex justify-content-center mt-4">
            <h4>
              <strong>Valor Total: </strong>
              {valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </h4>
          </div>

          <div className="mt-3 d-flex justify-content-center">
            <button
              className="btn btn-laranja btn-sm"
              style={{ minWidth: 180 }}
              onClick={this.handleCadastrarTodas}
              type="button"
              disabled={this.props.invalid || this.props.pristine} // 🔒 controla estado
            >
              Cadastrar Todas as Bagagens
            </button>
          </div>

        </div>
      </Autorizacao>
    );
  }
}

const seletor = formValueSelector('formularioCadastroBagagem');
export const mapStateToProps = state => {
  const reservasSelecionadas = state.remarcacao.reservasSelecionadas || [];
  const nomesCampos = reservasSelecionadas.flatMap(r => [
    `peso_${r.id}`,
    `valor_${r.id}`,
    `tipoCalculo_${r.id}`,
    `dinheiro_${r.id}`,
    `valorDinheiro_${r.id}`,
    `cartao_${r.id}`,
    `valorCartao_${r.id}`,
    `numeroComprovante_${r.id}`,
    `quantidadeParcelas_${r.id}`,
    `base64Comprovante_${r.id}`,
    `nomeComprovanteVenda_${r.id}`,
    `pix_${r.id}`,
    `valorPIX_${r.id}`,
    `numeroComprovantePIX_${r.id}`,
    `base64ComprovantePIX_${r.id}`,
    `nomeComprovanteVendaPIX_${r.id}`,
  ]);

  const formValues = seletor(state, ...nomesCampos);
    
  const reserva = reservasSelecionadas.find(it => it.habilitadoPrecoFixoExcessoBagagem);
  if (reserva) {
    const valorInicial = nomesCampos.filter(it => it.startsWith('valor_')).map(chave => {
      return { [chave]: reserva.precoFixoExcessoBagagem }
    })

    if (valorInicial && valorInicial.length) {
      const valor = valorInicial.reduce((acc, item) => {
        return {...acc, ...item}
      })

      return {
        initialValues: valor,
        empresaSelecionada: state.empresaSelecionada,
        reservasSelecionadas,
        formValues,

      };
    }
  }

  return {    
    empresaSelecionada: state.empresaSelecionada,
    reservasSelecionadas,
    formValues,

  };
};

export default withRouter(connect(mapStateToProps,
    {   changeFieldValue,
        cadastrarBagagem,
        selecionaBagagem,
    })(
  reduxForm({
    form: 'formularioCadastroBagagem',
    enableReinitialize: true,
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
    validate: validarFormulario,
  })(PainelCadastroBagagem)
));
